import "./NavbarElements.scss";

import styled from "styled-components";
import { NavLink as Link } from "react-router-dom";

import { FaBars } from "react-icons/fa";
import { CloseButton } from "@chakra-ui/react";

export const Nav = styled.nav`
  background-color: #d33852;
  height: 68px;
  display: flex;
  justify-content: space-between;
  padding: 0px calc((100vw - 1300px) / 2);
  z-index: 10;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;

  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    padding: 0px calc((100vw - 1024px) / 2);
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    padding: 0px calc((100vw - 768px) / 2);
  }
`;

export const NavLink = styled(Link)`
  color: #222222;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 0 1rem;

  cursor: pointer;
  z-index: 10;

  &.active {
    color: #ffffff;
    font-weight: 600;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #ffffff;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0px;
    right: 0px;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Close = styled(CloseButton)`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    color: #000000;
    top: 20px;
    left: 20px;
    font-size: 1.8rem;
    cursor: pointer;
    &:hover {
      color: #ffffff;
    }
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileNavMenu = styled.div`
  width: 70%;
  height: 100vh;
  background: #b0b0b0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;

  position: absolute;
  right: 0;

  z-index: 10;
  padding: 40px;
  border-radius: 20px 0 0 20px;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;
